import canvasScreenshot from 'canvas-screenshot'
import { useAssetVizInternal } from 'features/assetViz/AssetVizInternalProvider'
import html2canvas from 'html2canvas-pro'
import React from 'react'

/**
 * This invisible component is used to encapsulate logic required to take a
 * screenshot of the current AssetViz component, including any HtmlOverlays
 */
export const ScreenshotHandler: React.FC = () => {
  //----------------------------------------------------------------------------

  const { setController, assetVizDom } = useAssetVizInternal()

  /** takeScreenshot() returns a promise containing the screenshot blob */
  React.useEffect(
    () =>
      setController((prev) => ({
        ...prev,
        takeScreenshot: async () => {
          // Hack to prevent text from being shifted down, from
          // https://github.com/niklasvh/html2canvas/issues/2775#issuecomment-1316356991
          const style = document.createElement('style')
          document.head.appendChild(style)
          style.sheet?.insertRule(
            'body > div:last-child img { display: inline-block; }'
          )

          const screenshotCanvas = await html2canvas(assetVizDom!.current!, {
            backgroundColor: null,
          })
          style.remove()

          const blob = (await canvasScreenshot(screenshotCanvas, {
            useBlob: true,
            download: false,
          })) as Blob

          return blob
        },
      })),
    [setController, assetVizDom]
  )

  return <></>
}
